import { createFavoriteFilter } from '../../factories';
import { phoenixConfig } from '../../network';
import { fetchFavoriteList } from '../../services';

type Favorite = {
  assetId: number;
  createDate: number;
};

export async function fetchFavoriteChannels() {
  const { objects } = await fetchFavoriteList({
    filter: createFavoriteFilter({
      mediaTypeEqual: Number(phoenixConfig.assetsMediaTypes.Linear),
      orderBy: 'CREATE_DATE_ASC',
    }),
  });

  const favoritePositions: Map<number, number> = new Map();
  const favoriteDictionary: Record<number, Favorite> = {};
  const items: Favorite[] = [];

  objects.forEach((f, index) => {
    const favorite = {
      assetId: f.assetId,
      createDate: f.createDate,
    };
    favoritePositions.set(f.assetId, index);
    favoriteDictionary[f.assetId] = favorite;

    items.push(favorite);
  });

  return {
    favoriteDictionary,
    favoriteList: items,
    favoritePositions,
  };
}
